import { FC } from 'react';

import {
  MultiSelectionFilterWrapper,
  MultiSelectionItemsWrapper,
} from './MultiSelectionFilterStyle';
import { ListingFilterItemInterface, MultiSelectionFilterProps } from './types';
import MultiSelectionItem from './MultiSelectionFilterItem';

const MultiSelectionFilter: FC<MultiSelectionFilterProps> = ({
  data,
  handleSelectedItems,
  selectedItems,
  singleItemClassName,
  subTitleKey = 'subTitle',
  showExtraField = false,
  showSubTitle = false,
  withValue = false,
}) => {
  return (
    <MultiSelectionFilterWrapper>
      <MultiSelectionItemsWrapper>
        {data.map((item: ListingFilterItemInterface) => (
          <MultiSelectionItem
            key={item.key?.toString()}
            item={item}
            value={selectedItems.includes(item[withValue ? 'value' : 'key'])}
            onChange={(selected) => {
              item.selected = selected;
              if (selected) {
                handleSelectedItems([
                  ...selectedItems,
                  item[withValue ? 'value' : 'key'],
                ]);
              } else {
                handleSelectedItems(
                  selectedItems.filter(
                    (sKey) => sKey !== item[withValue ? 'value' : 'key']
                  )
                );
              }
            }}
            singleItemClassName={singleItemClassName}
            showExtraField={showExtraField}
            showSubTitle={showSubTitle}
            subTitleKey={subTitleKey}
          />
        ))}
      </MultiSelectionItemsWrapper>
    </MultiSelectionFilterWrapper>
  );
};

export default MultiSelectionFilter;
